import 'tinymce/icons/default';
import 'tinymce/themes/silver';
import { Component, effect, input, output, viewChild } from '@angular/core';
import { FormsModule, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { GalaxyRichTextEditorModule, RichTextEditorComponent } from '@vendasta/galaxy/rich-text-editor';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { debounceTime, map, take } from 'rxjs/operators';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyTooltipModule } from '@vendasta/galaxy/tooltip';
import { DynamicComponentDialogComponent } from '../dynamic-component-selector/dynamic-component-dialog/dynamic-component-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { CrmDynamicFieldService } from '../../services/crm-dynamic-field.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'email-input-with-dynamic-contents',
  templateUrl: './input-with-dynamic-contents.component.html',
  styleUrls: ['./input-with-dynamic-contents.component.scss'],
  imports: [
    MatProgressSpinnerModule,
    GalaxyFormFieldModule,
    GalaxyRichTextEditorModule,
    FormsModule,
    ReactiveFormsModule,
    MatIcon,
    TranslateModule,
    GalaxyTooltipModule,
  ],
})
export class InputWithDynamicContentsComponent {
  title = input<string>();
  titleHint = input<string>();
  required = input(false);
  content = input<string>();
  elementId = input.required<string>();
  contentChange = output<string>();
  protected readonly inputControl = new FormControl<string>('', []);
  private readonly richTextEditor = viewChild.required<RichTextEditorComponent>('textEditor');

  constructor(
    private readonly dialog: MatDialog,
    private readonly crmDynamicFieldService: CrmDynamicFieldService,
  ) {
    effect(() => {
      if (this.required()) {
        this.inputControl.setValidators([Validators.required]);
      }
    });
    this.crmDynamicFieldService
      .convertTemplateTagToHumanReadable$(toObservable(this.content))
      .pipe(take(1))
      .subscribe((value) => {
        this.inputControl.patchValue(value, { emitEvent: false });
      });

    this.inputControl.valueChanges.pipe(debounceTime(200), takeUntilDestroyed()).subscribe((val) => {
      const rendererContents = this.crmDynamicFieldService.convertRichTextToPlainTextWithDynamicVariables(val);
      this.contentChange.emit(rendererContents);
    });
  }

  protected openDialog(): void {
    const dialogRef = this.dialog.open(DynamicComponentDialogComponent, {
      autoFocus: false,
      width: '450px',
      height: '450px',
    });
    const result$: Observable<string> = dialogRef.afterClosed().pipe(map((res: string | null) => (res ? res : '')));
    this.crmDynamicFieldService
      .convertTemplateTagToHumanReadable$(result$)
      .pipe(take(1))
      .subscribe((res) => {
        if (res && res.trim() !== '') {
          this.richTextEditor().insertContent(res + ' '); //extra space to support scrolling to end
        }
      });
  }
}
